import ApplicationStore from '../stores/ApplicationStore';
import QuickstartStore from '../stores/QuickstartStore';
import loadDocument from './loadDocument';
import getQuickstartMetadata from '../util/getQuickstartMetadata';
import resolveQuickstart from '../util/resolveQuickstart';
import { setSelectClientForTutorial } from './performUserResourceActions';

const TutorialNavigatorActions = {};

TutorialNavigatorActions.home = (context) => {
  const selected = {};
  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

TutorialNavigatorActions.quickstartList = (context) => {
  const selected = {};

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

TutorialNavigatorActions.quickstart = (context, payload) => {
  const { params } = payload;
  const quickstarts = context.getStore(QuickstartStore).getQuickstarts();
  const selected = resolveQuickstart(quickstarts, params);

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

const loadQuickstart = async (context, payload) => {
  const { params } = payload;
  const quickstarts = context.getStore(QuickstartStore).getQuickstarts();
  const isFramedMode = context.getStore(ApplicationStore).isFramedMode();
  const selected = resolveQuickstart(quickstarts, params, isFramedMode);

  const metaData = await getQuickstartMetadata(selected);
  context.dispatch('QUICKSTART_SELECTED', { ...selected, isFramedMode });
  context.dispatch('UPDATE_PAGE_METADATA', metaData);
  await context.executeAction(loadDocument, { url: selected.url });
  await setSelectClientForTutorial(context, isFramedMode);
};

TutorialNavigatorActions.platform = loadQuickstart;
TutorialNavigatorActions.article = loadQuickstart;

export default TutorialNavigatorActions;
